import React from "react";
import { Container, Button } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";

function Donate() {
  const givingAreas = [
    {
      title: "Immediate community needs",
      description: "Help churches respond to basic necessities with dignity, speed, and consistency."
    },
    {
      title: "Economic opportunity",
      description: "Fund entrepreneurship and career development programs that build stability over time."
    },
    {
      title: "Financial resilience",
      description: "Support education and coaching that equips individuals and families to thrive."
    }
  ];

  return (
    <Container fluid className="project-section">
      <Container>
        <div className="section-shell">
          <div className="section-intro">
            <span className="section-eyebrow">Give</span>
            <h1 className="project-heading">
              Invest in a stronger network of community care.
            </h1>
            <p className="project-copy">
              Your donation helps Black
              Churches expand outreach and carry out their ministry of service by showing Christ’s
              compassion in their Community.
            </p>
          </div>

          <div className="donation-grid">
            {givingAreas.map((area) => (
              <div className="impact-card" key={area.title}>
                <strong>{area.title}</strong>
                <p>{area.description}</p>
              </div>
            ))}
          </div>

          <div className="cta-strip">
            <strong>Give where trust already exists.</strong>
            <p className="project-copy">
              Contributions large and small help churches respond now while building the long-term
              infrastructure communities need to flourish.
            </p>
          </div>

          <div className="hero-actions justify-content-center mt-4">
            <Button
              size="lg"
              href="https://www.paypal.com/donate/?hosted_button_id=SQP7F4A3KUWDU"
            >
              Donate Now
            </Button>
          </div>

          <div className="home-about-social mt-4 text-center">
            <h3>Questions about giving?</h3>
            <ul className="home-about-social-links justify-content-center">
              <li className="social-icons">
                <a
                  href="mailto:shared.success.foundation@gmail.com"
                  className="icon-colour home-social-icons"
                  aria-label="Email Shared Success Foundation"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default Donate;
